import Wrapper from './src/helper/wrapPageElement.jsx'

export const wrapPageElement = Wrapper
